import { Button } from '@mui/material';
import {
  DataGrid,
  GridCallbackDetails,
  GridColDef,
  GridPaginationModel,
  GridRenderCellParams
} from '@mui/x-data-grid';
import { useCallback, useMemo, useState } from 'react';
import {
  PreviewGridRow,
} from 'src/components/kanri/pages/jichitai/SearchSupportRecipientsPage/BulkSupporterAssignmentDialog/types';
import { SupportRecipientDialog } from 'src/components/kanri/pages/jichitai/SearchSupportRecipientsPage/SupportRecipientDialog';
import { appConst } from 'src/constants/common';
import { useNavigateSystemError } from 'src/hooks/common/useNavigateSystemError';

type ComponentProps = {
  rows: readonly PreviewGridRow[];
  rowCount: number;
  isLoading: boolean;
  paginationModel: GridPaginationModel;
  setPaginationModel: (model: GridPaginationModel, details: GridCallbackDetails) => void;
};

export const BulkSupporterAssignmentPreview = ({ rows, rowCount, isLoading, paginationModel, setPaginationModel }: ComponentProps) => {
  const [selectedPrsId, setSelectedPrsId] = useState<string>();
  const [supportRecipientDialogOpen, setSupportRecipientDialogOpen] = useState(false);
  const navigateSystemError = useNavigateSystemError();
  
  const detailButtonOnClick = useCallback((prsId: string) => {
    setSelectedPrsId(prsId);
    setSupportRecipientDialogOpen(true);
  }, []);

  const columns: GridColDef<PreviewGridRow>[] = useMemo(
    () => [
      { field: 'id', headerName: 'PrsId', width: 90 },
      { field: 'name', headerName: '氏名', width: 150, disableColumnMenu: true, sortable: false },
      { field: 'allBelongingSoshikinames', headerName: '要支援者の所属組織', width: 200, disableColumnMenu: true, sortable: false },
      { field: 'assignedSoshikinames', headerName: '割当済みの支援組織', width: 200, disableColumnMenu: true, sortable: false },
      { field: 'newlyAssignedSoshikinames', headerName: '新たに割り当てられる支援組織', width: 300, flex: 1,disableColumnMenu: true, sortable: false },
      {
        field: 'action',
        headerName: appConst.STR_EMPTY,
        disableColumnMenu: true,
        sortable: false,
        width: 90,
        minWidth: 90,
        maxWidth: 90,
        renderCell: (params: GridRenderCellParams<PreviewGridRow>) => (
          <Button
            fullWidth
            onClick={() => {
              detailButtonOnClick(params.row.id);
            }}
          >
            詳細
          </Button>
        ),
      },
    ],
    [detailButtonOnClick]
  );

  return (
    <>
      <DataGrid
        rows={rows}
        columns={columns}
        rowCount={rowCount}
        loading={isLoading} // 初回orページ切替時のみローディング表示
        paginationModel={paginationModel}
        paginationMode="server"
        onPaginationModelChange={setPaginationModel}
        disableRowSelectionOnClick
        pageSizeOptions={[]}
        localeText={{
          noRowsLabel: '新たに支援組織を割り当てられる要支援者はいません',
        }}        
        initialState={{
          columns: {
            columnVisibilityModel: {
              id: false,
            },
          },
        }}
        slotProps={{
          loadingOverlay: {
            variant: 'circular-progress',
            noRowsVariant: 'skeleton',
          },
        }}
      />
      <SupportRecipientDialog
        prsId={selectedPrsId}
        open={supportRecipientDialogOpen}
        onClose={() => {
          setSupportRecipientDialogOpen(false);
          setSelectedPrsId(undefined);
        }}
        onError={() => navigateSystemError()}
      />
    </>
  );
};
